import React from "react";
import { Row, Col } from "react-bootstrap";
import WpImage from "./WpImage";
import GenericWideSection from "./GenericWideSection";
import Arrow from "../images/arrow.svg";
import SectionHeader from "../components/SectionHeader";
import { VectorBackground } from "../components/VectorBackground";
import Link from "./Link";

const LifeAtAlgotraderLink = ({ link }) => {
    if (!link?.url) return null;

    return (
        <Link
            className="life-at-algotrader__link"
            to={link.url}
            target={link.target}
        >
            {link.title}
            <Arrow className="life-at-algotrader__arrow" />
        </Link>
    );
};

const LifeAtAlgotrader = ({
    header,
    subtitle,
    label,
    leadershipHeader,
    leadershipLink,
    leadershipLogos,
    leadershipText,
    investorsHeader,
    investorsText,
    workingAtHeader,
    workingAtText,
    workingAtLink,
}) => {
    return (
        <GenericWideSection
            vertical
            contentClassName="pb-0"
            containerClassName="life-at-algotrader-section"
        >
            <div className="life-at-algotrader">
                <VectorBackground gradient />
                <Row className="life-at-algotrader__cards-row">
                    <div className="generic-wide-section__head-wrap">
                        {header && (
                            <div className="life-at-algotrader__headline">
                                <SectionHeader
                                    header={header}
                                    labelTop={label}
                                />
                            </div>
                        )}
                        {subtitle && (
                            <div
                                className="generic-wide-section__subtitle"
                                dangerouslySetInnerHTML={{ __html: subtitle }}
                            />
                        )}
                    </div>
                    <Col xs="24" lg="12">
                        <div className="life-at-algotrader__card">
                            <h3 className="life-at-algotrader__title">
                                {leadershipHeader}
                            </h3>

                            <p className="life-at-algotrader__description">
                                {leadershipText}
                            </p>

                            <LifeAtAlgotraderLink link={leadershipLink} />
                        </div>
                    </Col>

                    <Col xs="24" lg="12">
                        <div className="life-at-algotrader__card">
                            <h3 className="life-at-algotrader__title">
                                {workingAtHeader}
                            </h3>

                            <p className="life-at-algotrader__description">
                                {workingAtText}
                            </p>

                            <LifeAtAlgotraderLink link={workingAtLink} />
                        </div>
                    </Col>
                </Row>

                <div className="life-at-algotrader__investors-card">
                    <h3 className="life-at-algotrader__title life-at-algotrader__title--center">
                        {investorsHeader}
                    </h3>

                    <p className="life-at-algotrader__description life-at-algotrader__description--center">
                        {investorsText}
                    </p>

                    <Row className="life-at-algotrader__logos">
                        {leadershipLogos.map(({ image }, index) => {
                            const imageData =
                                image?.localFile?.childImageSharp
                                    ?.gatsbyImageData;
                            const aspectRatio = imageData
                                ? imageData.width / imageData.height
                                : 1;

                            return (
                                <Col key={index} xs="12" md="6" lg="4">
                                    <div className="life-at-algotrader__logo">
                                        <WpImage
                                            image={image}
                                            style={{
                                                "--investor-logo-ratio":
                                                    aspectRatio,
                                            }}
                                        />
                                    </div>
                                </Col>
                            );
                        })}
                    </Row>
                </div>
            </div>
        </GenericWideSection>
    );
};

export default LifeAtAlgotrader;
